import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { Popup, Text } from './atoms';

const template = styled.div`
  ${({ theme, displayState }) => css`
    display: flex;
    align-items: center;
    position: relative;
    color: ${theme?.colour?.secondary}
    font-size: 12px;
    line-height: 14px;
    margin-top: 0px;

    span {
      display: none;
    }

    &:hover {
      span {
        display: ${displayState?.showPopup ? 'unset' : ''};
      }
    }
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Text,
      name: 'Rating',
      displayValue: ({ rating }) => rating.toString(),
    },
    {
      component: Popup,
      name: 'Popup',
      displayValue: ({ review }) => `Reviews: ` + review,
    }
  ],
})
